import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getForgotPasswordPath = returnPath("/auth/forgot-password");
export const getLoginPath = returnPath("/auth/login");
export const getLogoutPath = returnPath("/auth/logout");
